<div *ngIf="description$ | async as description" class="type" [ngStyle]="{ 'background-color': color$ | async }">
  {{ description }}
</div>
